module.exports = __webpack_public_path__ + "static/img/erweima_03.137b0c9f.jpg";